<template>
  <router-view/>
</template>
<script>
export default {
  name: 'Clients'
}
</script>
